import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '@/components/select-option-tag/select-option-tag.styles';

@customElement('sbk-select-option-tag')
export class SbkSelectOptionTag extends LitElement {
  @property() label = '';
  @property() value = '';

  static get styles() {
    return [styles];
  }

  render() {
    return html`
      <sbk-tag 
        href="javascript:void(0);" 
        title=${this.label} 
        area="select" 
        variant="muted" 
        hasCloseButton 
        @remove-tag=${this._onRemove}
        @keydown=${this._handleKeydown}>
        ${this.label}
      </sbk-tag>
    `;
  }

  private _onRemove(event: CustomEvent) {
    event.stopPropagation();
    this.dispatchEvent(new CustomEvent('remove-option', {
      detail: { value: this.value },
      bubbles: true,
      composed: true
    }));
  }

  private _handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();

      //Creates custom event for onRemove
      const customEvent = new CustomEvent('remove-option', {
        detail: { value: this.value },
        bubbles: true,
        composed: true
      });
      this._onRemove(customEvent);
    }
  }
}
